import { render, staticRenderFns } from "./SCardTypeExpenseComp.vue?vue&type=template&id=3e6797c2&"
import script from "./SCardTypeExpenseComp.vue?vue&type=script&lang=js&"
export * from "./SCardTypeExpenseComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports